import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromJobSourcing from './job-sourcing.reducer';

export interface JobSourcingState {
  sourcing: fromJobSourcing.State;
}

export const reducers = {
  sourcing: fromJobSourcing.reducer,
};

export const getJobSourcingFeatureState = createFeatureSelector<
  JobSourcingState
>('sourcing');

export const getJobSourcingState = createSelector(
  getJobSourcingFeatureState,
  state => state.sourcing
);

export const getSelectedEquestDraft = createSelector(
  getJobSourcingState,
  fromJobSourcing.getSelectedEquestDraft
);
export const getSelectedJobSourcing = createSelector(
  getJobSourcingState,
  fromJobSourcing.getSelectedJobSourcing
);
export const getSelectedFinnForm = createSelector(
  getJobSourcingState,
  fromJobSourcing.getSelectedFinnForm
);
export const getSelectedBoardsToCheckout = createSelector(
  getJobSourcingState,
  fromJobSourcing.getSelectedBoardsToCheckout
);
